// Supabase project. Set in .env (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY).
export const PLUME_CONFIG = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
};
